import clsx from 'clsx'
import { getRobotTypeDisplayName } from 'utils/robotTypeDisplayName'

import style from './RobotTypeLabel.module.css'

interface RobotTypeLabelProps {
  /** Robot type code (e.g. Sweeper, Combo). Hidden when empty or Unknown. */
  robotType?: string | null
  /** Vendor code to map type code to display name. */
  vendor?: string | null
  /** Use error style (e.g. when scenario has mixed mission types). */
  inconsistent?: boolean
}

const RobotTypeLabel = ({ robotType, vendor, inconsistent = false }: RobotTypeLabelProps) => {
  const display = getRobotTypeDisplayName(vendor ?? undefined, robotType)
  if (!display) return null
  return (
    <div
      className={clsx(style.robotType, {
        [style.robotTypeInconsistent]: inconsistent,
      })}
    >
      Robot type: {display}
    </div>
  )
}

export default RobotTypeLabel
